"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.Events = void 0;
var Events;
(function (Events) {
    Events[Events["NEXT"] = 0] = "NEXT";
    Events[Events["BACK"] = 1] = "BACK";
    Events[Events["DISABLE_STEPS"] = 2] = "DISABLE_STEPS";
    Events[Events["ENABLE_STEPS"] = 3] = "ENABLE_STEPS";
    Events[Events["SET_LABELS"] = 4] = "SET_LABELS";
    Events[Events["COMPLETE_STEP"] = 5] = "COMPLETE_STEP";
})(Events = exports.Events || (exports.Events = {}));
function reducer(state, action) {
    // Move to the previous step that isn't disabled
    if (action.type === Events.BACK) {
        var currentStep = state.currentStep - 1;
        while (state.disabledSteps.includes(currentStep)) {
            currentStep -= 1;
        }
        return __assign(__assign({}, state), { currentStep: currentStep });
    }
    // Move to the next step that isn't disabled and complete the current step
    if (action.type === Events.NEXT) {
        var currentStep = state.currentStep + 1;
        while (state.disabledSteps.includes(currentStep)) {
            currentStep += 1;
        }
        var updatedCompletedSteps = new Set(state.completedSteps);
        updatedCompletedSteps.add(state.currentStep);
        return __assign(__assign({}, state), { completedSteps: Array.from(updatedCompletedSteps.values()), currentStep: currentStep });
    }
    // Disable some steps. This will also remove completed steps and make them disabled instead.
    if (action.type === Events.DISABLE_STEPS) {
        var steps = action.payload.steps;
        var updatedDisabledSteps_1 = new Set(state.disabledSteps);
        var updatedCompletedSteps_1 = new Set(state.completedSteps);
        steps.forEach(function (step) {
            updatedDisabledSteps_1.add(step);
            updatedCompletedSteps_1.delete(step);
        });
        return __assign(__assign({}, state), { disabledSteps: Array.from(updatedDisabledSteps_1.values()), completedSteps: Array.from(updatedCompletedSteps_1.values()) });
    }
    // Enable steps that are disabled.
    if (action.type === Events.ENABLE_STEPS) {
        var steps_1 = action.payload.steps;
        var updatedDisabledSteps_2 = new Set(state.disabledSteps);
        state.disabledSteps.forEach(function (step) {
            if (steps_1.includes(step)) {
                updatedDisabledSteps_2.delete(step);
            }
        });
        return __assign(__assign({}, state), { disabledSteps: Array.from(updatedDisabledSteps_2.values()) });
    }
    // Update the labels with a new set.
    if (action.type === Events.SET_LABELS) {
        return __assign(__assign({}, state), { stepLabels: action.payload.stepLabels || state.stepLabels });
    }
    // Complete a single step
    if (action.type === Events.COMPLETE_STEP) {
        var completedSteps = new Set(state.completedSteps);
        completedSteps.add(action.payload.step);
        return __assign(__assign({}, state), { completedSteps: Array.from(completedSteps.values()) });
    }
    throw new Error('Invalid event type');
}
exports.reducer = reducer;
